/* Localize the legacy product calendar without changing its booking rules. */
(function () {
  'use strict';
  var i18n = (window.myselfie || {}).i18n || {};
  var $ = window.jQuery;
  if (!$ || !$.datepicker) return;

  var months = String(i18n.monthNames || '').split(',').map(function (s) { return s.trim(); });
  var defaults = { prevText: i18n.prevMonth, nextText: i18n.nextMonth };
  if (months.length === 12) defaults.monthNames = months;
  Object.keys(defaults).forEach(function (key) {
    if (!defaults[key]) delete defaults[key];
  });
  $.datepicker.setDefaults(defaults);

  function watchCalendar() {
    var calendar = document.getElementById('ui-datepicker-div') ||
      ($.datepicker.dpDiv && $.datepicker.dpDiv[0]);
    if (!calendar) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var loadRequested = false;
    /*
     * api-dates.js colours every sold-out / low day and always prints the whole legend. Here, without
     * touching it: days before today and lead-block days (backend field "lead") lose the booked / low
     * colouring (they render as plain disabled days), and a legend item is only shown when the visible
     * month still has a day with that status.
     */
    function adaptStatuses() {
      var av = window.myselfie && window.myselfie.availability;
      if (!av || typeof av.isLead !== 'function') return;
      if (!av.data) {
        if (!loadRequested && typeof av.load === 'function') {
          loadRequested = true;
          av.load().then(localize);
        }
        return;
      }
      var now = new Date();
      var todayIso = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
      calendar.querySelectorAll('td.wdn-booked, td.wdn-low').forEach(function (td) {
        var year = td.getAttribute('data-year');
        var month = td.getAttribute('data-month');
        var day = td.textContent.trim();
        if (year === null || month === null || !/^d+$/.test(day)) return;
        var iso = year + '-' + pad(Number(month) + 1) + '-' + pad(Number(day));
        if (iso < todayIso || av.isLead(iso)) {
          td.classList.remove('wdn-booked', 'wdn-low');
          td.removeAttribute('title');
        }
      });
      [['.wdn-legend-low', 'td.wdn-low'], ['.wdn-legend-booked', 'td.wdn-booked']].forEach(function (pair) {
        var show = !!calendar.querySelector(pair[1]);
        calendar.querySelectorAll(pair[0]).forEach(function (node) {
          var want = show ? '' : 'none';
          if (node.style.display !== want) node.style.display = want;
        });
      });
    }
    function localize() {
      adaptStatuses();
      [
        ['.wdn-legend-available', i18n.legendAvailable],
        ['.wdn-legend-low', i18n.legendLow],
        ['.wdn-legend-booked', i18n.legendSoldOut]
      ].forEach(function (entry) {
        if (!entry[1]) return;
        calendar.querySelectorAll(entry[0]).forEach(function (node) {
          if (node.textContent !== entry[1]) node.textContent = entry[1];
        });
      });
      [['td.wdn-low', i18n.lowTooltip], ['td.wdn-booked', i18n.fullyBooked]].forEach(function (entry) {
        if (!entry[1]) return;
        calendar.querySelectorAll(entry[0]).forEach(function (node) {
          if (node.title !== entry[1]) node.title = entry[1];
        });
      });
    }
    new MutationObserver(localize).observe(calendar, { childList: true, subtree: true });
    localize();
  }
  // Observe the singleton even before the availability response attaches it to the page.
  $(watchCalendar);
})();
